import { render, staticRenderFns } from "./hdraces-bets.vue?vue&type=template&id=aee3c7aa&scoped=true"
import script from "./hdraces-bets.vue?vue&type=script&lang=js"
export * from "./hdraces-bets.vue?vue&type=script&lang=js"
import style0 from "./hdraces-bets.vue?vue&type=style&index=0&id=aee3c7aa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee3c7aa",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/bets/hdraces-bets.vue
// module id = toZj
// module chunks = 0